import { computed, Injectable, signal } from "@angular/core";

let nid = 0;

@Injectable({ providedIn: 'root' })
export class MobileService {

  private isDeviceMobile = signal(false);
  private overrideMobile = signal(false);
  private mobileOverride = signal(false);
  id = nid++;

  mobile = computed(() => {
    if (this.overrideMobile()) {
      return this.mobileOverride();
    }
    return this.isDeviceMobile();
  });

  constructor() {
    window.matchMedia("(max-width: 600px)").addEventListener('change', (event) => {
      this.isDeviceMobile.set(event.matches);
    });
  }

  setMobileOverride(mobile: boolean|null) {
    if (mobile !== null) {
      this.overrideMobile.set(true);
      this.mobileOverride.set(mobile);
    } else {
      this.overrideMobile.set(false);
    }
  }
}
